import styled from 'styled-components';
import { ListItem, ListItemText } from '@mui/material';
import { colorTheme } from '@styles/muiTheme';

export const ListHeader = styled(ListItem)`
  background-color: ${colorTheme.palette.secondary.light};
  color: ${colorTheme.palette.common.black};
  border-radius: 8px 8px 0px 0px;
  font-weight: bold;
  font-size: 10;
  display: flex;
  justify-content: flex-start;
  align-items: left;
`;

export const ListRow = styled(ListItem)`
  color: ${colorTheme.palette.common.black};
  font-size: 10;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px 10px;
`;

export const XmlWrapper = styled.div`
  border:1px solid ${colorTheme.palette.secondary.main};
  padding: 20px;
  overflow-Y: auto;
  max-height: 70vh;
`;

export const StyledListLabel = styled(ListItemText)`
  width: 35%;
  font-size: 12px; 
  
  span {
    font-weight: bold;
  }
`;

export const StyledListValue = styled(ListItemText)`
  width: 55%;
  font-size: 12px;
`;